module.exports = __webpack_public_path__ + "img/kitkitphoto9.d0632f4b.jpg";